var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLockProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2269_11648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 4.58333V2.91667C2.91667 2.36413 3.13616 1.83423 3.52686 1.44353C3.91756 1.05283 4.44747 0.833332 5 0.833332C5.55253 0.833332 6.08244 1.05283 6.47314 1.44353C6.86384 1.83423 7.08333 2.36413 7.08333 2.91667V4.58333M2.08333 4.58333H7.91667C8.3769 4.58333 8.75 4.95643 8.75 5.41667V8.33333C8.75 8.79357 8.3769 9.16667 7.91667 9.16667H2.08333C1.6231 9.16667 1.25 8.79357 1.25 8.33333V5.41667C1.25 4.95643 1.6231 4.58333 2.08333 4.58333Z",
    stroke: "#C4D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2269_11648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockProgress);
export default __webpack_public_path__ + "static/media/icon-lock-progress.6d2541d6fe603df43b5a642a93f03ea4.svg";
export { ForwardRef as ReactComponent };